export default __webpack_public_path__ + "81bd026916fc5f0dad8e44ece4f3837b.png";